module.exports = __webpack_public_path__ + "img/tarjetaF.6efca775.png";